import { useParams, useSearchParams } from "react-router-dom";
import { ulidSchema } from "../schemas/commonSchema";

/**
 * paramNameで指定されたIDをパスから取得します。
 * 存在しない or ULID形式でない場合はエラーを投げる
 */
export const useSafeId = (paramName: string): string => {
  const params = useParams<Record<string, string | undefined>>();
  const value = params[paramName];
  const result = ulidSchema.safeParse(value);
  if (!result.success) {
    throw new Error(`不正なパスです: '${paramName}'`);
  }
  return result.data;
};

const optionalSchema = ulidSchema.optional();
/**
 * paramNameで指定されたIDをパスから取得します。
 * 存在しない場合は undefinedを返します。
 * ULID形式でない場合はエラーを投げる
 */
export const useOptionalId = (paramName: string): string | undefined => {
  const params = useParams<Record<string, string | undefined>>();
  const value = params[paramName];
  const result = optionalSchema.safeParse(value);
  if (!result.success) {
    throw new Error(`不正なパスです: '${paramName}'`);
  }
  return result.data;
};

/**
 * paramNameで指定されたIDをクエリパラメータから取得します。
 * 存在しない or ULID形式でない場合はエラーを投げる
 */
export const useSafeQueryId = (paramName: string): string => {
  const [searchParams] = useSearchParams();
  const id = searchParams.get(paramName);
  const result = ulidSchema.safeParse(id);
  if (!result.success) {
    throw new Error(`不正なクエリです: '${paramName}'`);
  }
  return result.data;
};

/**
 * paramNameで指定されたIDをクエリパラメータから取得します。
 * 存在しない場合は undefinedを返します。
 * ULID形式でない場合はエラーを投げる
 */
export const useOptionalQueryId = (paramName: string): string | undefined => {
  const [searchParams] = useSearchParams();
  const id = searchParams.get(paramName);
  const result = optionalSchema.safeParse(id);
  if (!result.success) {
    throw new Error(`不正なクエリです: '${paramName}'`);
  }
  return result.data;
};
